import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatLargeNumber'
})
export class FormatLargeNumberPipe implements PipeTransform {

  transform(value: string): string {
    const num = parseFloat(value);
    if (isNaN(num)) return value;

    // Keep the exact decimal representation provided in the string input
    // (e.g. value coming from toFixed(2) => "23.19"). We only add
    // thousand separators to the integer part and append the decimal
    // part if present.
    const [integerPart, decimalPart] = value.split('.');

    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    if (decimalPart !== undefined && decimalPart.length > 0) {
      return `${formattedIntegerPart}.${decimalPart}`;
    }

    return formattedIntegerPart;
  }

}
